import isNotLoggedIn from "src/shared/utilities/graphql/isNotLoggedIn";

import apolloClient from "../connection/apolloClient";
import VIEWER from "../queries/viewer";

const getCurrentUser = async () => {
  let viewer;

  try {
    viewer = await apolloClient.query({ query: VIEWER });
  } catch (error) {
    if (isNotLoggedIn(error)) {
      return false;
    }

    throw new Error(error);
  }

  return viewer;
};

export default getCurrentUser;
